/**
 * "What you can do with your chart" CTAs (HORO-10360).
 *
 * The chart view can be open over the chat (modal) or on /profile/birth-chart
 * (page), and the tarot / horoscope starters live inside ChatPage's own
 * handlers. Rather than thread callbacks through the modal host, the CTA leaves
 * a one-shot request in sessionStorage and pokes the chat page:
 *
 *   - already on a chat route → dispatch `bc:start-experience`, which ChatPage
 *     is listening for;
 *   - anywhere else → navigate to Veda's chat, where ChatPage reads the same
 *     flag on mount.
 *
 * Either way the same code path runs, so there is one behaviour to reason about.
 */
import { APP_URL_CHAT } from '../const';

export const BC_EXPERIENCE = { TAROT: 'tarot', HOROSCOPE: 'horoscope' };
export const BC_START_EXPERIENCE_EVENT = 'bc:start-experience';
const STORAGE_KEY = 'bc_pending_experience';
const DEFAULT_ADVISOR_PATH = `/${APP_URL_CHAT}/veda`;

/** Read and clear the pending request. Returns 'tarot' | 'horoscope' | null. */
export const consumePendingExperience = () => {
    if (typeof window === 'undefined') return null;
    try {
        const value = window.sessionStorage.getItem(STORAGE_KEY);
        window.sessionStorage.removeItem(STORAGE_KEY);
        return Object.values(BC_EXPERIENCE).includes(value) ? value : null;
    } catch {
        return null;
    }
};

/**
 * @param {'tarot'|'horoscope'} kind
 * @param {{ navigate: Function, pathname: string }} ctx  from react-router
 */
export const startExperienceFromChart = (kind, { navigate, pathname }) => {
    try {
        window.sessionStorage.setItem(STORAGE_KEY, kind);
    } catch {
        // best-effort — without it the user just lands in chat
    }
    if (pathname.startsWith(`/${APP_URL_CHAT}/`)) {
        window.dispatchEvent(new Event(BC_START_EXPERIENCE_EVENT));
    } else {
        navigate(DEFAULT_ADVISOR_PATH);
    }
};
